module.exports = __webpack_public_path__ + "img/EthnicRacialDist1900.79372313.jpg";